import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function InputFileUpload({ handleImageFileChange }) {
  return (
    <Button
      onChange={handleImageFileChange}
      sx={{ marginRight: "1em" }}
      component="label"
      variant="contained"
      size="small"
      startIcon={<CloudUploadIcon />}
    >
      Upload new image
      <VisuallyHiddenInput type="file" />
    </Button>
  );
}

export default InputFileUpload;
